import React from 'react';

import { getConfigProp, getDebugState } from '@atlas/core';

const DebugInfo = () => {
  if (!getDebugState()) {
    return;
  }

  const commit = getConfigProp('commitVersion');
  const theme = getConfigProp('themeVersion');

  return (
    <div className="debug-info">
      <div>Commit version: {commit}</div>
      <div>Dyeing version: {theme}</div>
    </div>
  );
};

export default DebugInfo;
